<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style>
/* グローバルCSS変数と共通スタイル */
:root {
  font-size: 16px;
  --boki-black: #231f20;
  --boki-pink: #ed088c;
}

/* グローバルリセット */
html, body {
  height: 100vh;
  margin: 0;
  padding: 0;
  font-family: 'MS PGothic', Arial, 'Hiragino Kaku Gothic Pro', sans-serif;
  font-size: 13px;
  line-height: 1.4;
  color: #333333;
  background-color: #FFFFFF;
  word-break: break-all;
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
  box-sizing: border-box;
}

#app {
  height: 100vh;
  width: 100vw;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Viewごとのoverflowコントロール */
.exam-view {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  box-sizing: border-box;
}

.start-view {
  height: 100vh;
  overflow: hidden;
  box-sizing: border-box;
}

.result-view {
  height: 100vh;
  width: 100vw;
  overflow: auto;
  box-sizing: border-box;
}

.top-view {
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
}

/* 共通リンクスタイル */
a {
  color: #0088cc;
  text-decoration: none;
}

a:hover {
  color: #005580;
  text-decoration: underline;
}

/* 共通ボタンスタイル */
.btn {
  display: inline-block;
  padding: 4px 12px;
  margin-bottom: 0;
  font-size: 14px;
  line-height: 20px;
  color: #333;
  text-align: center;
  text-shadow: 0 1px 1px rgba(255, 255, 255, 0.75);
  vertical-align: middle;
  cursor: pointer;
  background-color: #f5f5f5;
  background-image: -moz-linear-gradient(top, #fff, #e6e6e6);
  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#fff), to(#e6e6e6));
  background-image: -webkit-linear-gradient(top, #fff, #e6e6e6);
  background-image: -o-linear-gradient(top, #fff, #e6e6e6);
  background-image: linear-gradient(to bottom, #fff, #e6e6e6);
  background-repeat: repeat-x;
  border: 1px solid #ccc;
  border-color: #e6e6e6 #e6e6e6 #bfbfbf;
  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
  border-bottom-color: #b3b3b3;
  border-radius: 4px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05);
  text-decoration: none;
}

.btn:hover,
.btn:focus {
  color: #333;
  text-decoration: none;
  background-color: #e6e6e6;
}

/* 共通フォームスタイル */
input, textarea, select {
  font-family: 'MS PGothic', Arial, 'Hiragino Kaku Gothic Pro', sans-serif;
}

/* 共通テキストスタイル */
h1, h2, h3 {
  margin: 0;
  font-weight: bold;
}

h1 {
  font-size: 1.5em;
  line-height: 1.2;
}

p {
  margin: 1em 0;
  line-height: 1.6;
}

/* 共通ユーティリティクラス */
.tc { text-align: center; }
.tr { text-align: right; }
.tl { text-align: left; }

.pull-left { float: left; }
.pull-right { float: right; }

/* 共通グリッドシステム（基本的なもの） */
.container {
  width: 100%;
  padding-right: 20px;
  padding-left: 20px;
  margin: 0 auto;
}

.row {
  width: 100%;
}

.row:before, .row:after {
  display: table;
  line-height: 0;
  content: "";
}

.row:after {
  clear: both;
}

/* 共通のテキストラベル */
.text-label {
  display: inline;
  padding: 2px 4px;
  font-size: 11.844px;
  font-weight: bold;
  line-height: 14px;
  color: #fff;
  white-space: nowrap;
  vertical-align: baseline;
  background-color: #999;
  border-radius: 3px;
}
</style>
